import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'

import { IChecklistApprovalWrapper } from './IChecklistApprovalWrapper'
import { ChecklistApproval } from '@core/entities/checklist/ChecklistApproval'
import { User } from '@core/entities/user'
import { localizedStrings } from '@core/strings'

export class ChecklistApprovalWrapper extends Entity<IChecklistApprovalWrapper> {
  action?: 'APPROVED' | 'REJECTED'

  @Type(() => ChecklistApproval)
  approval?: ChecklistApproval

  @Type(() => User)
  submittedBy?: User

  submittedOn?: string

  reason?: string

  signatureId?: number

  public static new(payload: unknown): ChecklistApprovalWrapper {
    const entity = plainToInstance(ChecklistApprovalWrapper, payload)

    return entity
  }

  public getSectionHeading(): string {
    const approvalLabel =
      this.approval?.label === 'Default Approval' ? '' : this.approval?.label

    if (this.action === 'REJECTED') {
      const prefix = approvalLabel ? `${approvalLabel} - ` : ''
      return `${prefix}${localizedStrings.rejected}`
    }

    return approvalLabel ? approvalLabel : localizedStrings.approver
  }
}
